module.exports = __webpack_public_path__ + "img/1-39.f92b3293.png";